import { Modal } from "antd";
import SpecialOfferForm from "../SpecialOffer/SpacialOfferForm";

const UpdateSpecialOfferModal = ({ isOpen, onClose, offerId, offer }) => {
  return (
    <Modal
      // title="Update Special Offer"
      open={isOpen}
      onCancel={onClose}
      width={800}
      footer={null}
      
    >
      <SpecialOfferForm
        offerId={offerId}
        offer={offer}
        onClose={onClose}
        onSuccess={() => onClose()}
      />
    </Modal>
  );
};

export default UpdateSpecialOfferModal;
